<div class="evidence-container">
    <div class="modal-header">
        <h4 class="modal-title">Upload Evidence</h4>
    </div>
    <div class="modal-body evidence">
        <form *ngIf="!isReadOnly" [formGroup]="form" (ngSubmit)="submit(form)">    
            
            <div class="row">
                <div class="col-sm-12">
                    <label class="form-label">Upload Evidence
                        <i class="fas fa-info-circle" aria-hidden="true"
                            [ngbPopover]="toolTipContent" popoverTitle="Details"
                            placement="bottom" 
                            triggers="mouseenter:mouseleave"></i>
                        </label>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-10">
                    <div class="form-group">
                        <ng-template #toolTipContent>
                            Files are limited to:<br>
                                <ul>
                                    <li>-20 MB size</li>
                                    <li>-Standard documents (PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, TXT, RTF), images (JPG, PNG, JPEG, GIF), and audio files ( WAV, M4A, MP3)</li>
                                </ul>
                        </ng-template>
                        <input type="file" class="form-control h-auto" placeholder="Upload Document" accept=".gif,.jpg,.jpeg,.tiff,.png,.doc,.docx,.xls,.xlsx,.pdf,.txt,.rtf,.ppt,.pptx,.m4a,.mp3,.mp4,.wav,.aac"
                            (change)="onChange($event)"/>
                        <br/><input type="text" class="form-control" placeholder="Display Name (Optional)" formControlName="DisplayName"/>
                    </div>
                </div>
                <div class="col-lg-2">
                    <div class="form-group">
                        <button type="submit" class="btn btn-primary" [disabled]="form.invalid">Upload</button>
                    </div>
                </div>
            </div>
        </form>
        <div class="row">
            <div class="col-12">
                <h5>Existing Evidence</h5>

                <div class="evidence-list-container">
                    <p *ngIf="files?.length === 0">There are currently no evidence files uploaded.</p>

                    <ul>
                        <li *ngFor="let file of files">
                            <div class="flex-nowrap evidence-item-container">
                                <div>
                                    <i class="document {{ icon(file.FileName) }}" aria-hidden="true" ></i>
                                </div>
                                <div class="overflow-text">
                                    <a href="Javascript://" (click)="viewEvidence(file)">{{ file.DisplayName }}</a>
                                    <div>{{ file.UploadByDisplayName }}</div>
                                    <div>{{ file.UploadDate | date: 'MMMM dd, yyyy h:mm a' }}</div>
                                </div>
                                <div *ngIf="canDelete(file)" class="text-end">
                                    <ng-template #confirmDelete>
                                        <div class="row">
                                            <div class="col-12">
                                                <p>Are you sure you want to delete this evidence?</p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6 text-end">
                                                <button class="btn btn-danger" (click)="deleteEvidence(file); p.close()">Yes</button>
                                            </div>
                                            <div class="col-6 text-start">
                                                <button class="btn btn-info" (click)="p.close()">Cancel</button>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <a href="Javascript://"
                                    [ngbPopover]="confirmDelete"
                                    popoverTitle="Confirm"
                                    triggers="manual"
                                    placement="left"
                                    container="body"
                                    #p="ngbPopover" (click)="p.open()"><i class="fas fa-times-circle"></i></a>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="canClose" class="modal-footer">
        <button type="button" class="btn btn-info" (click)="activeModal.close(files.length)">Close</button>
    </div>
</div>
